import Vue from 'vue';
import Router from 'vue-router';
import paths from './paths';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import store from '../store';
import { canAccessRoute, getFirstAllowedPage } from '../utils/permissionHelpers';

Vue.use(Router);
const router = new Router({
    base: '/',
    mode: 'history',
    linkActiveClass: 'active',
    routes: paths
});
// router gards
router.beforeEach(async (to, from, next) => {
    NProgress.start();
    
    // Skip permission check for public routes
    if (to.meta && to.meta.public) {
        next();
        return;
    }
    
    // Check if user is authenticated
    if (!store.state.user) {
        next({ name: 'Login' });
        return;
    }
    
    // Check permissions for the route
    const userPermissions = store.state.user.permissions || [];
    const routeName = to.name;
    
    if (routeName && !canAccessRoute(routeName, userPermissions)) {
        // User doesn't have permission, redirect to first allowed page.
        // Guard against an infinite redirect loop if the fallback would also be
        // denied (or is the same route) — otherwise next() keeps re-firing.
        const firstPage = getFirstAllowedPage(userPermissions);
        if (firstPage && firstPage.name && firstPage.name !== routeName) {
            next(firstPage);
        } else {
            next();
        }
        return;
    }
    
    next();
});

router.afterEach(() => NProgress.done());

export default router;
